'use client';

import React from 'react';
import { useShallow } from 'zustand/react/shallow';
import AccountsDrawer from './Drawers/AccountsDrawer';
import LiquidationDetailsDrawer from './Drawers/HistoryDrawers/LiquidationDetailsDrawer/LiquidationDetailsDrawer';
import { useDrawersStore } from 'src/stores/useDrawersStore';
import { InsuranceFundVaultDrawer } from './Drawers/InsuranceFundVaultDrawer/InsuranceFundVaultDrawer';
import { PositionDrawer } from './Drawers/PositionDrawer/PositionDrawer';
import { MarketDetailsDrawer } from './Drawers/MarketDetailsDrawer/MarketDetailsDrawer';
import BorrowLendDetailsDrawer from './Drawers/BorrowLendDetailsDrawer/BorrowLendDetailsDrawer';
import { VaultDetailsDrawer } from './Drawers/Vaults/VaultDetailsDrawer';
import VaultDisplayFiltersDrawer from './Drawers/Vaults/VaultDisplayFiltersDrawer';
import { ListYourVaultDrawer } from './Drawers/ListYourVaultDrawer';
import AccountHotkeySelectionDrawer from './Drawers/AccountsDrawer/AccountHotkeySelectionDrawer';

export default function AppDrawers() {
	const [
		showAccountsDrawer,
		showLiquidationDetailsDrawer,
		showInsuranceFundVaultDrawer,
		showMarketDetailsDrawer,
		showBorrowLeandDetailsDrawer,
		showPositionDrawer,
		showVaultDetailsDrawer,
		showVaultDisplayFiltersDrawer,
		showListYourVaultDrawer,
		showAccountHotkeySelectionDrawer,
	] = useDrawersStore(
		useShallow((s) => [
			s.accounts.show,
			s.liquidations.show,
			s.insuranceFundVault.show,
			s.marketDetails.show,
			s.borrowLendDetails.show,
			s.position.show,
			s.vaultDetails.show,
			s.vaultDisplayFilters.show,
			s.listYourVault.show,
			s.accountHotkeySelection.show,
		])
	);

	return (
		<>
			{showLiquidationDetailsDrawer && <LiquidationDetailsDrawer />}
			{showInsuranceFundVaultDrawer && <InsuranceFundVaultDrawer />}
			{showMarketDetailsDrawer && <MarketDetailsDrawer />}
			{showVaultDetailsDrawer && <VaultDetailsDrawer />}
			{showBorrowLeandDetailsDrawer && <BorrowLendDetailsDrawer />}
			{showPositionDrawer && <PositionDrawer />}
			{showListYourVaultDrawer && <ListYourVaultDrawer />}
			{showAccountsDrawer && <AccountsDrawer />}
			{showVaultDisplayFiltersDrawer && <VaultDisplayFiltersDrawer />}
			{showAccountHotkeySelectionDrawer && <AccountHotkeySelectionDrawer />}
		</>
	);
}
